module.exports = __webpack_public_path__ + "img/add1.6e6a049a.png";